module.exports = __webpack_public_path__ + "static/img/tel.20d8e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tel.jpg
// module id = Sc6r
// module chunks = 1